module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MTDEH8/tc-custom/9781638299363.jpg?1726483131601",
      "alt": "This image is the cover for the book The Gift of God’s Word"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Gift of God’s Word\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('em', [_vm._v("“Oh, Lord, tell me!")])]), _c('p', [_c('em', [_vm._v("How was His body when He ascended to Your heavenly center?")])]), _c('p', [_c('em', [_vm._v("Was He brightly magnificent in holiness prepared to heaven enter?")])]), _c('p', [_c('em', [_vm._v("Was He clothed in purity and devotion, though stripped by our sin?")])]), _c('p', [_c('em', [_vm._v("Was He wearing goodness and sanctity as He entered therein?”")])]), _c('p', [_vm._v("From the poem “His Body,” the eminently spiritual poetic verse from the pen of D. Ferris Arfaa contains the meaning and effect for which so many people are searching today.")]), _c('p', [_vm._v("Guided by the intent of divine inspiration, the author’s collection of verse, "), _c('em', [_vm._v("The Gift of God’s Word,")]), _vm._v(" is just that: a magnificent gift!")]), _c('p', [_vm._v("Realized from scripture, this book contains poems that reflect on the teachings and life of Jesus Christ as revealed in the gospels of Luke and Matthew.")]), _c('p', [_vm._v("They are invented to uplift, educate, and illuminate God’s love and the power of faith, while establishing and understanding the way toward salvation. And that’s the best gift of all!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      D. Ferris Arfaa\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("D. Ferris Arfaa hopes that the book’s spiritual conception will be of interest to others seeking a higher, more intellectual, connection to God. Now, retired and a resident of Delaware, this attorney-at-law turned poet graduated magna cum laude while earning a bachelor’s degree in finance from the Notre Dame of Maryland University. A Doctor of Law degree followed from the University of Baltimore School of Law, as did many awards for legal and community involvement in Maryland. D. Ferris Arfaa was a registered nurse before receiving her degree in finance and an Adjunct Professor of Business Law at Notre Dame of Maryland University from 2000 to 2004. Moreover, this poet is the author of the highly inspirational poetic verse penned in 2021, "), _c('em', [_vm._v("From the First Nightingale to the Last.")])])]), _c('p', {
    staticStyle: {
      "margin": "0cm 0cm 8pt",
      "font-size": "15px",
      "font-family": "Calibri, sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Read more: dferrisarfaa.com")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers \n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0